<script setup lang="ts">
const route = useRoute()
const { data: blogs } = await useAsyncData(
  () => `blogs-${route.query.search ?? ''}`,
  () =>
    $fetch(`/intl-api/blogs`, {
      params: {
        search: route.query.search
      }
    }),
  { watch: [() => route.query.search] }
)

if (!blogs.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Blog not found'
  })
}

useDefaultMeta({
  title: 'Informasi Scale up Bisnis Terlengkap | Blog KiriminAja',
  description:
    'Temukan informasi lengkap tentang bisnis, e-commerce &amp; tips keuangan di sini! Kirim paket COD multi ekspedisi | Blog KiriminAja',
  author: 'Content Team'
})
</script>

<template>
  <BlogSectionCategory />
  <section class="py-6 lg:py-10">
    <UiContainer class="mb-3">
      <h1 class="text-xl font-display lg:text-3xl font-bold">
        <template v-if="!route.query.search || blogs?.items.length">
          Scale up Bisnis bersama <span class="text-primary">KiriminAja</span>
        </template>
        <template v-else-if="route.query.search">
          Artikel
          <span class="text-primary">{{ route.query.search }}</span> Tidak
          ditemukan
        </template>
      </h1>
    </UiContainer>
    <BlogSectionBase
      :search="route.query.search?.toString()"
      :blogs="blogs?.items ?? []"
      :meta="blogs?.meta"
    />
    <BlogSectionFeatured v-if="!route.query.search" />
  </section>
  <CtaSection />
</template>
